"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESTRICTED_EXTENSIONS = exports.RestrictedExtensions = exports.ACCEPTED_FILE_EXTENSIONS = exports.FileExtensions = exports.MIN_SIZE_TO_UPLOAD_SINGLE_FILE = exports.EVIDENCE_MAX_SIZE = void 0;
exports.EVIDENCE_MAX_SIZE = 10000000;
exports.MIN_SIZE_TO_UPLOAD_SINGLE_FILE = 5000000;
var FileExtensions;
(function (FileExtensions) {
    FileExtensions["MS_WORD_DOC"] = ".doc";
    FileExtensions["MS_WORD_DOT"] = ".dot";
    FileExtensions["OPENXML_DOCX"] = ".docx";
    FileExtensions["OPENXML_DOTX"] = ".dotx";
    FileExtensions["MS_POWERPOINT_PPT"] = ".ppt";
    FileExtensions["MS_POWERPOINT_POT"] = ".pot";
    FileExtensions["MS_POWERPOINT_PPS"] = ".pps";
    FileExtensions["MS_POWERPOINT_PPA"] = ".ppa";
    FileExtensions["OPENXML_PPTX"] = ".pptx";
    FileExtensions["OPENXML_POTX"] = ".potx";
    FileExtensions["OPENXML_PPSX"] = ".ppsx";
    FileExtensions["MS_EXCEL_XLS"] = ".xls";
    FileExtensions["MS_EXCEL_XLT"] = ".xlt";
    FileExtensions["MS_EXCEL_XLA"] = ".xla";
    FileExtensions["OPENXML_XLSX"] = ".xlsx";
    FileExtensions["OPENXML_XLTX"] = ".xltx";
    FileExtensions["OPEN_DOC_TXT"] = ".odt";
    FileExtensions["OPEN_DOC_PRESENTATION"] = ".odp";
    FileExtensions["OPEN_DOC_SPREADSHEET"] = ".ods";
    FileExtensions["AUDIO_MP3"] = ".mp3";
    FileExtensions["VIDEO_MP4"] = ".mp4";
    FileExtensions["VIDEO_MPEG"] = ".mpeg";
    FileExtensions["VIDEO_WEBM"] = ".webm";
    FileExtensions["IMG_WEBP"] = ".webp";
    FileExtensions["AUDIO_WAV"] = ".wav";
    FileExtensions["AUDIO_WEBA"] = ".weba";
    FileExtensions["PDF"] = ".pdf";
    FileExtensions["TXT"] = ".txt";
    FileExtensions["SVG"] = ".svh";
    FileExtensions["GIF"] = ".gif";
    FileExtensions["JPG"] = ".jpg";
    FileExtensions["PNG"] = ".png";
    FileExtensions["JP2"] = ".jp2";
    FileExtensions["JPC"] = ".jpc";
})(FileExtensions = exports.FileExtensions || (exports.FileExtensions = {}));
exports.ACCEPTED_FILE_EXTENSIONS = [...Object.values(FileExtensions)];
var RestrictedExtensions;
(function (RestrictedExtensions) {
    RestrictedExtensions["SH"] = ".sh";
    RestrictedExtensions["DOCM"] = ".docm";
    RestrictedExtensions["DOTM"] = ".dotm";
    RestrictedExtensions["XLSM"] = ".xlsm";
    RestrictedExtensions["XLTM"] = ".xltm";
    RestrictedExtensions["XLAM"] = ".xlam";
    RestrictedExtensions["PPTM"] = ".pptm";
    RestrictedExtensions["POTM"] = ".potm";
    RestrictedExtensions["PPAM"] = ".ppam";
    RestrictedExtensions["PPSM"] = ".ppsm";
    RestrictedExtensions["SLDM"] = ".sldm";
    RestrictedExtensions["INF"] = ".inf";
    RestrictedExtensions["LNK"] = ".lnk";
    RestrictedExtensions["SCF"] = ".scf";
    RestrictedExtensions["MSH"] = ".msh";
    RestrictedExtensions["MSH1"] = ".msh1";
    RestrictedExtensions["MSH2"] = ".msh2";
    RestrictedExtensions["MSH_XML"] = ".mshxml";
    RestrictedExtensions["MSH1_XML"] = ".msh1xml";
    RestrictedExtensions["MSH2_XML"] = ".msh2xml";
    RestrictedExtensions["PS1"] = ".ps1";
    RestrictedExtensions["PS1_XML"] = ".ps1xml";
    RestrictedExtensions["PS2"] = ".ps2";
    RestrictedExtensions["PS2_XML"] = ".ps2xml";
    RestrictedExtensions["PSC1"] = ".psc1";
    RestrictedExtensions["PSC2"] = ".psc2 ";
    RestrictedExtensions["BAT"] = ".bat";
    RestrictedExtensions["CMD"] = ".cmd";
    RestrictedExtensions["VB"] = ".vb";
    RestrictedExtensions["VBS"] = ".vbs";
    RestrictedExtensions["VBE"] = ".vbe";
    RestrictedExtensions["JS"] = ".js";
    RestrictedExtensions["JSE"] = ".jse";
    RestrictedExtensions["WS"] = ".ws";
    RestrictedExtensions["WSF"] = ".wsf";
    RestrictedExtensions["WSC"] = ".wsc";
    RestrictedExtensions["WSH"] = ".wsh";
    RestrictedExtensions["MSP"] = ".msp";
    RestrictedExtensions["COM"] = ".com";
    RestrictedExtensions["SCR"] = ".scr";
    RestrictedExtensions["HTA"] = ".hta";
    RestrictedExtensions["CPL"] = ".cpl";
    RestrictedExtensions["MSC"] = ".msc";
    RestrictedExtensions["JAR"] = ".jar";
    RestrictedExtensions["EXE"] = ".exe";
    RestrictedExtensions["PIF"] = ".pif";
    RestrictedExtensions["APPLICATION"] = ".application";
    RestrictedExtensions["GADGET"] = ".gadget";
    RestrictedExtensions["MSI"] = ".msi";
    RestrictedExtensions["PHP"] = ".php";
    RestrictedExtensions["JSX"] = ".jsx";
    RestrictedExtensions["TS"] = ".ts";
    RestrictedExtensions["TSX"] = ".tsx";
    RestrictedExtensions["ZIP"] = ".zip";
    RestrictedExtensions["TAR"] = ".tar";
    RestrictedExtensions["TARGZ"] = ".tar.gz";
})(RestrictedExtensions = exports.RestrictedExtensions || (exports.RestrictedExtensions = {}));
exports.RESTRICTED_EXTENSIONS = [...Object.values(RestrictedExtensions)];
//# sourceMappingURL=file.constants.js.map